import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const WhatsAppWidget = ({ phoneNumber }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleWidget = () => {
    setIsExpanded(!isExpanded);
  };
  
  const handleWhatsAppClick = () => {
    if (!phoneNumber) {
      alert('WhatsApp number is not available at the moment.');
      return;
    }
    const message = encodeURIComponent('Hello! I am interested in your real estate services.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };
  
  // If no phone number is available, don't render the widget
  if (!phoneNumber) {
    return null;
  }
  
  return (
    <div className={`whatsapp-widget ${isExpanded ? 'expanded' : ''}`}>
      {isExpanded ? (
        <div className="whatsapp-widget-expanded">
          <div className="whatsapp-widget-header">
            <div className="whatsapp-widget-logo">
              <FontAwesomeIcon icon={faWhatsapp} />
            </div>
            <div className="whatsapp-widget-title">
              <h4>Chat with us</h4>
              <p>Online | Typically replies instantly</p>
            </div>
            <button 
              className="whatsapp-widget-close" 
              onClick={toggleWidget}
              aria-label="Close WhatsApp widget"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="whatsapp-widget-body">
            <p>Hello! 👋</p>
            <p>How can we help you today?</p>
          </div>
          <button 
            className="whatsapp-widget-button"
            onClick={handleWhatsAppClick}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
            <span>Start Chat</span>
          </button>
        </div>
      ) : (
        <button 
          className="whatsapp-widget-icon"
          onClick={toggleWidget}
          aria-label="Open WhatsApp chat"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </button>
      )}
    </div>
  );
};

export default WhatsAppWidget;
